import React, { useEffect, useState } from 'react';
import type { RouteComponentProps } from 'react-router-dom';

import useTitle from 'hooks/useTitle';
import DesignationForm from './components/DesignationForm';
import Loading from 'components/common/loading/Loading';
import BackButton from 'components/common/button/BackButton';

import * as designationService from 'services/designation';

import { DESIGNATION } from 'constants/routes';

import history from 'utils/history';
import { handleError } from 'utils/errorHandler';

import type { Designation } from 'interface/designation';

type MatchParams = {
  id?: string;
};

type Props = RouteComponentProps<MatchParams>;

type FetchByIdResponse = {
  data: Designation;
};

function AddEditDesignation(props: Props) {
  const designationId = props.match.params?.id;

  const title = designationId ? 'Edit Designation' : 'Add Designation';
  const setTitle = useTitle();

  useEffect(() => {
    setTitle(title);
  }, [title, setTitle]);

  const [isLoading, setIsLoading] = useState(Boolean(designationId));
  const [designation, setDesignation] = useState<Designation | undefined>(undefined);

  const getPageTitle = (loadedDesignation: Designation) => {
    if (!loadedDesignation.name) {
      return 'Edit Designation';
    }

    return `Edit Designation - ${loadedDesignation.name}`;
  };

  useEffect(() => {
    if (!designationId) {
      return;
    }

    const fetchDesignation = async () => {
      try {
        const response = (await designationService.fetchById(designationId)) as FetchByIdResponse;
        const { data } = response;

        setTitle(getPageTitle(data));

        const { id, name, description, status } = data;
        setDesignation({ id, name, description: description ?? null, status });
      } catch (error) {
        handleError(error);
        history.push(DESIGNATION);
      } finally {
        setIsLoading(false);
      }
    };

    void fetchDesignation();
  }, [designationId, setTitle]);

  return (
    <div className="full-scope-card">
      <div className="full-scope-card__header table-header name-wrap">
        <div className="d-flex flex-row">
          <BackButton />
          <div className="d-flex flex-row">
            <div className="table-header">
              <h3 className="text-bold">{title}</h3>
            </div>
          </div>
        </div>
      </div>

      {isLoading ? (
        <div className="loading-min-height">
          <Loading />
        </div>
      ) : (
        <DesignationForm designation={designation} />
      )}
    </div>
  );
}

export default AddEditDesignation;
